import { Box, CircularProgress } from '@mui/material';
import { FC, ReactNode } from 'react';

type Props = {
  isLoading?: boolean;
  children: ReactNode;
};

const Loader: FC<Props> = ({ isLoading, children }) =>
  isLoading ? (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <CircularProgress />
    </Box>
  ) : (
    children
  );

export default Loader;
